import axios from 'axios'
import store from './app/store'
const appid = '462a78a9d3ddb1c5bfaa532d983d6936'

async function request(options) {
  return (await axios.request(options)).data
}

export async function forecast5Day(city) {
  const key = store.getState().userKey.key
  const active = store.getState().userKey.active
  const lat = city.coord.lat
  const lon = city.coord.lon
  const usekey = active && key ? key : appid
  let options = {
    method: 'GET',
    url: 'https://api.openweathermap.org/data/2.5/onecall',
    params: { lat: lat, lon: lon, appid:usekey, units: 'metric', lang: 'it' }
  };
  let data = await request(options)
  return { ...data, city: city }
}